/**
 * FormErrors Component
 * Responsible for showing APPLICATION type errors received from server
 *
 * Params:
 * errors: array of tdWbErrors: the "errors" array property from server error response (ie 400 error)
 * errorKeyNamespace: string: a locale key prefix to translate errors. Translation key will be derived by appending error key to
 * the errorKeyNamespace.
 * usage:
 * html:
 * <td-wb-form-errors [errors]="consumerErrors" errorKeyNamespace="tdWb.form"></td-wb-form-errors>
 *
 * code:
 * <promise>.then(success, (err) => (this.consumerErrors = err.errors);
 */
import {
  Component,
  Input
} from '@angular/core';

import { RestErrorType } from '../../../domain/error.domain';
import { PipesModule } from '../../../pipes/pipes.module';
import type { BackendError } from '../../../domain/error.domain';
import type { InterpolateParams } from '../../../pipes/translate.pipe';

@Component({
  selector: 'td-wb-form-errors',
  templateUrl: 'form-errors.component.html',
  imports: [PipesModule]
})
export class FormErrorsComponent {
  @Input() errors: Array<BackendError>;
  @Input() errorKeyNamespace: string;

  constructor() {
    this.errors = [];
    this.errorKeyNamespace = null;
  }

  applicationErrors(): Array<BackendError> {
    if (this.errors !== undefined) {
      return this.errors.filter((error: BackendError): boolean => error.type === RestErrorType.APPLICATION);
    }
    return [];
  }

  getErrorKey(error: BackendError): string {
    if (error.code !== undefined && error.code !== null) {
      if (this.errorKeyNamespace !== undefined && this.errorKeyNamespace !== null) {
        return `${this.errorKeyNamespace}.${error.code}`;
      }
      return error.code;
    }
  }

  getErrorKeyParams(error: BackendError): InterpolateParams {
    return error.arguments as unknown as InterpolateParams;
  }

  trackByCode(index: number, item: BackendError): string {
    if (item.code !== undefined && item.code !== null) {
      return item.code;
    }
    return `${index}`;
  }
}
